export const RECENT_LOGS_FOR_ALERTING_DAY_LIMIT = 7;